import axios from 'axios';


const api = axios.create({
  baseURL: 'https://p6weufi9uy.us-east-1.awsapprunner.com/api/',
});

export default api;
